/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSucceededReceiptContent
 */
export interface PaymentSucceededReceiptContent {
    /**
     * 
     * @type {string}
     * @memberof PaymentSucceededReceiptContent
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSucceededReceiptContent
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSucceededReceiptContent
     */
    key?: string;
}

/**
 * Check if a given object implements the PaymentSucceededReceiptContent interface.
 */
export function instanceOfPaymentSucceededReceiptContent(value: object): value is PaymentSucceededReceiptContent {
    return true;
}

export function PaymentSucceededReceiptContentFromJSON(json: any): PaymentSucceededReceiptContent {
    return PaymentSucceededReceiptContentFromJSONTyped(json, false);
}

export function PaymentSucceededReceiptContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSucceededReceiptContent {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'key': json['key'] == null ? undefined : json['key'],
    };
}

export function PaymentSucceededReceiptContentToJSON(json: any): PaymentSucceededReceiptContent {
    return PaymentSucceededReceiptContentToJSONTyped(json, false);
}

export function PaymentSucceededReceiptContentToJSONTyped(value?: PaymentSucceededReceiptContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
        'key': value['key'],
    };
}

